<template>
    <div class="table_wrap mt10">
        <div class="filter_wrap">
            <div class="filter_row">
                <div class="filter_content">
                    <div class="filter_titleBox mr15">
                        <span class="filter_title">발행일</span>
                    </div>
                    <div class="filter">
                        <el-date-picker
                                class="datePicker_long"
                                v-model="filterDate"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                @change="setFilterFunc('cr', filterDate)"
                                start-placeholder="시작일"
                                end-placeholder="종료일"
                                :editable="false"
                        >
                        </el-date-picker>
                    </div>
                </div>
            </div>
            <div class="filter_row">
                <div class="filter_content">
                    <div class="filter_titleBox mr15">
                        <span class="filter_title">판매 상태</span>
                    </div>
                    <div class="filter" style="  display: inline-block; vertical-align: middle;">
                        <el-select class="filter" v-model="filterUtilitySalesStatus" @change="setFilterArrayFunc('sellst', filterUtilitySalesStatus)">
                            <el-option :value="''" :label="'전체'"></el-option>
                            <el-option v-for="(data, value) in utilitySalesStatus" :key="`utilitySalesStatus${value}`"
                                       :label="data.name" :value="data.value"></el-option>
                        </el-select>
                    </div>

                    <div class="filter_titleBox mr15">
                        <span class="filter_title">사용 상태</span>
                    </div>
                    <div class="filter" style="  display: inline-block; vertical-align: middle;">
                        <el-select class="filter" v-model="filterUtilityUseStatus" @change="setFilterArrayFunc('usest', filterUtilityUseStatus)">
                            <el-option :value="''" :label="'전체'"></el-option>
                            <el-option v-for="(data, value) in utilityUseStatus" :key="`utilityUseStatus${value}`"
                                       :label="data.name" :value="data.value"></el-option>
                        </el-select>
                    </div>

                    <div class="filter_titleBox ml10 mr15">
                        <span class="filter_title">상위 카테고리</span>
                    </div>
                    <div class="filter" style="  display: inline-block; vertical-align: middle;">
                        <el-select class="filter" v-model="filterUtilityParentCategory" @change="setFilterArrayFunc('uc_parent_id', filterUtilityParentCategory)">
                            <el-option :value="''" :label="'전체'"></el-option>
                            <el-option v-for="(data, value) in parentCategory" :key="`utilityParentCategory${value}`" :label="data.uc_name ? data.uc_name : '-'" :value="data.uc_idx"></el-option>
                        </el-select>
                    </div>

                    <div class="filter_titleBox ml10 mr15">
                        <span class="filter_title">하위 카테고리</span>
                    </div>
                    <div class="filter" style="display: inline-block; vertical-align: middle;">
                        <el-select class="filter" v-model="filterUtilityChildCategory"
                                   @change="setFilterArrayFunc('uc_idx', filterUtilityChildCategory)">
                            <el-option :value="''" :label="'전체'"></el-option>
                            <el-option v-for="(data, value) in returnChildCategory" :key="`utilityChildCategory${value}`"
                                       :label="data.name" :value="data.uc_idx"></el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="filter_row">
                <div class="filter_content">
                    <div class="filter_titleBox mr15">
                        <span class="filter_title">검색 구분</span>
                    </div>
                    <div style="display: inline-block; vertical-align: middle;">
                        <div class="short mr10" style="display: inline-block; vertical-align: middle;">
                            <el-select class="el-select" v-model="searchInputOption">
                                <el-option v-for="(data, value) in utilitySearchType" :key="`utilitySearchType${value}`" :value="data.value" :label="data.name">
                                </el-option>
                            </el-select>
                        </div>
                        <el-input v-model="searchInput"
                                  @keypress.enter.native="setFilterFunc(searchInputOption, searchInput)"
                                  placeholder="검색어를 입력해 주세요." class="short mr10"></el-input>
                        <el-button class="com_search" @click="setFilterFunc(searchInputOption, searchInput)">
                            검색
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="filter-show-count mt15 mb15">
            <el-select class="veryShort" v-model="size" @change="changePage('size', size)">
                <el-option v-for="(sizeData) in sizeList" :key="`size${sizeData}`" :value="sizeData"
                           :label="`${sizeData}개씩 보기`"></el-option>
            </el-select>

        </div>
    </div>
</template>

<script>

import util from "@/mixins/util";
import {utilityFilterSalesStatus, utilityFilterUseStatus,utilityFilterSearchType} from "@/service/utilityService"
import utilityUtil from "@/components/utility/utilityUtil";

const {filterConfig} = utilityUtil;
export default {
    name: "UtilityFilterDefaultLayout",
    mixins: [],
    components: {},
    inject: ['setPage', 'setFilter'],
    provide() {
        return {}
    },
    props: {
        filterData: {
            default: () => {
            }
        },
        paginationData: {default: {total: 0, page: 0, size: 0,}},
        parentCategory : {
            default : () => []
        },
        childCategory : {
            default : () => []
        },
    },
    data() {
        return {
            filterDate: '',
            searchInputOption: 'u_name',
            searchInput: '',
            filterUtilitySalesStatus: '',
            filterUtilityUseStatus: '',
            filterUtilitySearchType: '',
            filterUtilityParentCategory: '',
            filterUtilityChildCategory: '',
            utilitySalesStatus : utilityFilterSalesStatus,
            utilityUseStatus : utilityFilterUseStatus,
            utilitySearchType : utilityFilterSearchType,
            size: 10,
            sizeList: [10, 30, 50],
            filterParentCategory : [],
            filterChildCategory : {}
        }
    },
    created() {
    },
    mounted() {
        this.setterFilterDataInData();
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {
        returnChildCategory(){
            return this.childCategory[this.filterUtilityParentCategory]
        }
    },
    methods: {
        setterFilterDataInData() {
            let classnames = Object.keys(this.filterData);
            classnames.forEach(classname => {
                let obj = this.filterData[classname];
                let type = filterConfig[obj.key].type;
                if (this.hasOwnProperty(classname)) {
                    if (type == 'query') {
                        this[classname] = obj.query;
                        if (this.hasOwnProperty(classname + 'Option')) {
                            this[classname + 'Option'] = obj.key;
                        }
                    } else if (type === 'between') {
                        this[classname] = [obj.start, obj.end];
                    } else if (type === 'match') {
                        let arr = obj.value.split(',');
                        if (arr.length > 1) {
                            let numArr = []
                            for (let i of arr) {
                                numArr.push(Number(i))
                            }
                            ;
                            this[classname] = numArr
                        } else if (isNaN(obj.value)) {
                            this[classname] = obj.value;
                        } else {
                            this[classname] = Number(obj.value);
                        }

                    } else if (type === 'terms') {
                        if (isNaN(obj.terms[0])) {filterUtilityParentCategory
                            this[classname] = obj.terms[0];
                        } else {
                            this[classname] = Number(obj.terms[0]);
                        }

                    }

                }
            })
            this.size = this.paginationData.size;
        },
        // 데이터가 1개이지만 array형식으로 보내야 할 때 사용
        setFilterArrayFunc(key, value) {
            if(key=== 'uc_parent_id'){
                this.filterUtilityChildCategory = '';
                this.setFilterArrayFunc('uc_idx',this.filterUtilityChildCategory);                
            }
            let arr = []
            if (!util.isEmpty(value)) {
                arr.push(value)
            }
            this.setFilter(key, arr);
        },
        setFilterFunc(key, value) {
            this.setFilter(key, value);
        },
        changePage(key, value) {
            this.setPage(key, value);
            this.setPage('page', 1);
        },
        checkFilterData() {
            return this.filterDate != null && this.filterDate.length > 0;
        },
    },
    watch: {},
}
</script>

<style lang="scss">


</style>
